import React from 'react';
import { Autocomplete, Box, Chip, TextField } from '@mui/material';
import FormSelectField from '../../../../Components/CustomUIElements/FormSelectField';
import { EqualsFieldProps } from '../type';
import { sharedClasses } from '../../../../Components/CustomUIElements/sharedClasses';

/**
 * EqualsField component handles the answer selection part of the auto tagging condition
 * It displays the "equals" label and either:
 * - MultiSelect for CheckBoxField type questions (allowing multiple choices)
 * - FormSelectField for other question types (single choice)
 */
const EqualsField: React.FC<EqualsFieldProps> = ({
  field,
  fieldIndex,
  statusIndex,
  supportedQuestions,
  autoTagConditions,
  handleChangeField,
  updateAutoTagConditionMutation
}) => {
  // Determine if this is a checkbox field
  const isCheckboxField =
    supportedQuestions.filter(
      (question) => question.id === field.question.id || field.question.id === 0
    )[0]?.type === 'CheckBoxField';

  return (
    <>
      <h4>equals</h4>
      {isCheckboxField ? (
        // For CheckBoxField, use MultiSelect to allow selecting multiple choices
        <Box sx={{ width: '290px' }}>
          <Autocomplete
            clearIcon={false}
            options={
              supportedQuestions
                .filter(
                  (question) => question.id === field.question.id || field.question.id === 0
                )[0]
                ?.field_choices?.map((choice) => ({
                  name: choice.name,
                  id: choice.id
                })) || []
            }
            getOptionLabel={(option) => option.name}
            value={field.choices}
            onChange={(_, newValues) => {
              const choiceIds = newValues.map((choice) => choice.id);
              handleChangeField(statusIndex, fieldIndex, choiceIds, 'a');
            }}
            multiple
            sx={sharedClasses.formAutocomplete}
            slotProps={{ listbox: { style: sharedClasses.autoCompleteListStyles } }}
            renderTags={(value, props) =>
              value.map((option, index) => (
                <Chip label={option.name} {...props({ index })} key={index} />
              ))
            }
            renderInput={(params) => (
              <TextField slotProps={{ inputLabel: { shrink: true } }} {...params} />
            )}
            disabled={
              !autoTagConditions[statusIndex]?.fields[fieldIndex]?.question.id ||
              updateAutoTagConditionMutation.isPending
            }
          />
        </Box>
      ) : (
        // For other field types, use FormSelectField for single choice
        <FormSelectField
          label="Answer"
          options={supportedQuestions
            .filter((question) => question.id === field.question.id || field.question.id === 0)[0]
            ?.field_choices?.map((choice) => ({
              value: choice.id.toString(),
              label: choice.name
            }))}
          defaultValue={field.choices && field.choices[0] ? field.choices[0].id.toString() : ''}
          onChange={(value) => handleChangeField(statusIndex, fieldIndex, Number(value), 'a')}
          styles={{ width: '290px' }}
          isDisabled={
            !autoTagConditions[statusIndex]?.fields[fieldIndex]?.question.id ||
            updateAutoTagConditionMutation.isPending
          }
        />
      )}
    </>
  );
};

export default EqualsField;
